import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import './lianTuoRecruitInfo.less'
export default {
    name: "lianTuoRecruitInfo",
    data() {
        return {
            isEmail: false,
            rollList: [
                {
                    src: "img/lianTuoRecruitInfo/as2.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruitInfo/as3.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruitInfo/as1.png",
                    size: 4,
                },
                {
                    src: "img/lianTuoRecruitInfo/as2.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruitInfo/as3.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruitInfo/as1.png",
                    size: 2,
                },
                {
                    src: "img/lianTuoRecruitInfo/as2.png",
                    size: 3,
                },
                {
                    src: "img/lianTuoRecruitInfo/as3.png",
                    size: 2,
                },
            ],
            talk: {
                person: '— 张庭辉， 数字商业事业部研发工程师',
                info: [
                    '“找到⼀个能投资我并帮助我成长为⼯程师的地⽅很重要。我在联拓数科发现了这一点！”'
                ]
            },
            infoData: [
                {
                    name: "产品经理",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 负责零售业务ToB、ToC解决方案和产品方案设计;",
                        "2. 对业务方进行需求调研，归纳总结业务流程的设计;",
                        "3. 独立完成产品调研和规划，撰写需求文档;",
                        "4. 组织产品评审，推进零售业务解决方案相关系统产品化落地。",
                    ],
                    tex2: [
                        "1. 3年以上信息化系统、互联网平台产品经理工作经验，从事过零售相关系统规划工作;",
                        "2. 对零售实体企业的总部运营管理流程、财务管理流程、进销存管理流程有深入了解;",
                        "3. 具备丰富的敏捷开发经验，能快速推进产品落地进程;",
                        "4. 全面掌握产品概要设计，ER图，BRD，MRD，PRD，接口设计等相关工作;",
                        "5. 能够熟练使用Axure，墨刀，Visio等工具设计系统原型和流程图;",
                        "6. 具备较强的组织协调能力，判断力，优秀的沟通能力、计划和执行能力，具备突出的团队合作精神，富有创新精神。",
                    ],
                    state: false,
                },
                {
                    name: "Java开发工程师",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 参与项目的需求调研和需;",
                        "2. 参与需求讨论和撰写数据库设计文档、系统设计文档，系统实现和维护；",
                        "3. 参与支付系统及周边系统的研发工作；",
                        "4. 与团队配合完成需求开发、测试及上线的整个流程；",
                        "5. 大数据（基于hive) 相关系统功能开发及维护。",
                    ],
                    tex2: [
                        "1. 计算机或相关统招本科学历以上，3年（含）及以上Java开发经验，有Jvm内核者经验优先； ",
                        "2. Java基础知识扎实，热爱新技术，有互联网金融，支付相关开发经验优先；",
                        "3. 熟 悉 MVC, 熟 练 掌 握 Spring,Hibernate，Mybatis 技术 ； ",
                        "4. 精通Java语言和面向对象设计方法，了解J2EE构架及中间件、XML，Json等相关技术知识；",
                        "5. 多个web项目开发经验,熟悉html,javascript,jquery,div,CSS等常用Web技术和知识；",
                        "6. 熟悉eclipse,svn,maven等开发工具,熟悉tomcat等常用应用服务器，熟悉 MySQL数据库；",
                        "7. 熟悉SOA服务治理框架（Duboo）、Redis、MongoDB及MQ消息队列；",
                        "8. 有良好的沟通能力和团队协作能力，责任心强并具备一定的抗压能力；",
                        "9. 有大数据（hive) 经验者优先。",
                    ],
                    state: false,
                },
                {
                    name: "前端开发工程师",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 负责Web前端项目的架构设计与优化；",
                        "2. 负责核心项目业务功能开发及维护；",
                        "3. 配合产品经理，实现 UI 及 UE 各方面的需求，持续优化，提升用户体验；",
                        "4. 规划研究前沿技术与技术创新，与业务相结合，提升团队的技术水平、开发效率和质量。",
                    ],
                    tex2: [
                        "1. 统招本科及以上学历，4年以上相关经验，计算机相关专业优先；",
                        "2. 熟练运用 JavaScript 语言与 HTML5 、CSS3 等技术；",
                        "3. 熟悉模块化、前端编译和构建工具，掌握微信小程序开发框架、或 react、Vue框架中的一种 ， 并深入理解其设计原理。",
                        "4. 对技术有强烈的进取心，具有良好的沟通能力和团队合作精神、优秀的分析问题和解决问题的能力。",
                    ],
                    state: false,
                },
                {
                    name: "测试工程师",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 负责营销和私域流量相关系统的功能性测试（重点：餐饮及商城）；",
                        "2. 快速熟悉需求，深入理解业务流程，理解系统内部工作原理，根据需求制定测试计划；",
                        "3. 根据产品需求文档，负责测试用例的编写及维护；",
                        "4. 执行测试过程中，能准确描述bug产生的过程，准确定位并跟踪，推动问题及时合理地解决；",
                        "5. 跟进项目迭代，进行功能测试、兼容性测试，自动化测试等，保证产品质量和项目进度；",
                        "6. 编写测试报告、产品上线后，负责上线确认过程。",
                    ],
                    tex2: [
                        "1. 大专及以上学历，有3年以上测试经验；",
                        "2. 有餐饮系统或商城系统测试经验优先；",
                        "3. 熟练编写自动化脚本的优先；",
                        "4. 有较强的逻辑能力及抗压性，有责任心，可以胜任重复性工作，工作细致认真，有耐心；",
                        "5. 良好的团队协作精神，较强的沟通能力和表达能力，做事认真负责，能够独立完成测试任务。",
                    ],
                    state: false,
                },
                {
                    name: "渠道经理",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 根据公司的销售目标，开拓本地收银系统软硬件代理商或移动支付行业的代理商；",
                        "2. 结合客户的痛点及需求，为客户提供专业的新零售移动支付营销解决方案；",
                        "3. 协助上级主管完成公司下达的销售任务和各项销售指标；",
                        "4. 负责市场信息的收集、反馈，市场活动的组织、策划和执行；",
                        "5. 协同产品、运营等跨团队力量，共同推动业务落地，并持续优化。",
                    ],
                    tex2: [
                        "1. 具备2年以上微信支付，支付宝口碑，收银软硬件，会员卡券营销等渠道销售经验优先；",
                        "2. 对代理商有一定了解，有较强的商务拓展和合作洽谈经验，沟通能力，挖掘客户需求达成共赢方案；",
                        "3. 良好的客户公关、销售谈判、客户关系维护能力、团队合作精神，能承受较大的工作压力；",
                        "4. 能吃苦、主动性强，细心好学，对产品有热情。",
                    ],
                    state: false,
                },
                {
                    name: "HRBP",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 负责开发、引进外部人才，组织实施招聘工作，并参与对应聘人员的面试筛选，控制部门预算，降低费用成本 ；",
                        "2. 受理员工投诉，并组织相关部门妥善解决，受理员工与公司劳动争议事宜并及时解决；",
                        "3. 代表公司与员工签订各种劳动合同，公司内部员工档案的建立与管理；",
                        "4. 对新员工进行企业制度与文化的培训工作，建立企业形象执行企业管理规章制度、行政人事 管理制度以及工作流程、绩效考核制度的运行；",
                        "5. 负责员工考勤系统的维护和数据整理；",
                        "6. 负责做好公司来宾的接待安排，组织、协调公司年会、员工活动；",
                        "7. 协助组织公司通用规章制度的拟定、修改和编写工作，并参与标准及；管理制度的拟定、 讨论、修改工作，对文件中涉及的重要事项进行跟踪检查和督 导，推进公司的管理；",
                        "8. 制定、控制行政采购成本及预算；",
                        "10. 撰写各类通知、简报、汇报材料及公司文件，协助各部门做好节假日期间工作安排。",
                    ],
                    tex2: [
                        "1. 人力资源等相关专业，本科以上学历；",
                        "2. 三年以上相关工作经验；",
                        "3. 熟悉办公人事管理知识及工作流程，熟悉公文写作格式，熟练运用OFFICE等办公软件；",
                        "4. 工作仔细认真、责任心强、为人正直，具备较强的书面口头表达能力及较强的主动服务意识。",
                    ],
                    state: false,
                },
                {
                    name: "运营储备生",
                    area: "北京",
                    position: "全职",
                    tex1: [
                        "1. 负责产品的日常运营和管理工作，包括日常问题解答与需求收集、配合各部门 间的衔接工作；",
                        "2. 合理安排时间进度，制作时间进度表，保证产品功能按时迭代；",
                        "3. 了解市场竞品功能与政策，完善产品不足；",
                        "4. 根据公司和部门战略部署，与商家进行有效沟通，获取对部门发展建议及形成可行性改进方案；",
                        "5. 能够对商家的促销活动和选品进行把控和指导，给予可行性改进方案，围绕市场反馈及用户需求， 及时提出合理运营计划并予以调整实施。",
                    ],
                    tex2: [
                        "1. 有互联网电商行业背景或者有线下相关运营经验者优先；",
                        "2. 专科及以上学历；",
                        "3. 极强的执行能力，沟通表达能力强；",
                        "4. 较强的市场分析及预测能力； 5. 具有良好的职业操守。",
                    ],
                    state: false,
                },
            ]
        }
    },
    components: {
        skeleton,
        vueSeamlessScroll
    },
    methods: {
        showList(index){
            let _this = this;
            if(_this.infoData[index].state === true){
                _this.infoData[index].state = false;
            }else{
                _this.infoData[index].state = true;
            }
        },
        emailChange(){
            let _this = this;
            if(_this.isEmail === false){
                _this.isEmail = true;
            }else{
                _this.isEmail = false;
            }
        }
    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
